import { GenericApi } from '@linktivity/linkapis';
import config from '../config';

const activityService = new GenericApi.ActivityApi(config);

export { activityService };
